import { render, staticRenderFns } from "./GreenProduct.vue?vue&type=template&id=7e6bb592&scoped=true&"
import script from "./GreenProduct.vue?vue&type=script&lang=ts&"
export * from "./GreenProduct.vue?vue&type=script&lang=ts&"
import style0 from "./GreenProduct.vue?vue&type=style&index=0&id=7e6bb592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6bb592",
  null
  
)

export default component.exports